import AllergyForm from './AllergyForm';
import {save} from '../../app-components/action/SaveAction';
import {cancelButton} from '../../app-components/action/CloseAction';
let header = {
  title: 'Add Allergy',
  actions: [cancelButton(), save()],
};

export default AllergyForm({header});
